import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function NewsSidebarSection() {
  const latestNews = articles.slice(0, 5);

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          {/* Left - Latest News List */}
          <div className="lg:col-span-8">
            <div className="flex items-center justify-between mb-8">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary-500" />
                <h2 className="text-xl md:text-2xl font-bold text-foreground-900">最新爆料</h2>
              </div>
              <Link
                to="/category/entertainment"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
              >
                更多
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line" />
                </span>
              </Link>
            </div>

            <div className="space-y-4">
              {latestNews.map((article, index) => (
                <article
                  key={article.id}
                  className="group flex gap-4 md:gap-5 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200 hover:border-primary-200 transition-all duration-300"
                >
                  <div className="flex-shrink-0 w-24 h-20 md:w-32 md:h-24 rounded-lg overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      width="320"
                      height="240"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1.5">
                      <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700">
                        {article.category}
                      </span>
                      {article.isHot && (
                        <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-primary-100 text-primary-700">
                          热
                        </span>
                      )}
                    </div>
                    <Link
                      to={`/article/${article.slug}`}
                      className="block text-sm md:text-base font-semibold text-foreground-900 leading-snug mb-1.5 line-clamp-2 group-hover:text-primary-500 transition-colors"
                    >
                      {article.title}
                    </Link>
                    <p className="text-xs text-foreground-400 line-clamp-1 hidden sm:block">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
                      <span>{article.author}</span>
                      <span>{article.date}</span>
                      <span className="flex items-center gap-1">
                        <span className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-eye-line" />
                        </span>
                        {article.views.toLocaleString()}
                      </span>
                    </div>
                  </div>
                  <div className="hidden md:flex flex-col items-center justify-center gap-1 text-foreground-300">
                    <span className="text-lg font-bold text-foreground-400">{(index + 1).toString().padStart(2, '0')}</span>
                  </div>
                </article>
              ))}
            </div>
          </div>

          {/* Right - Sidebar */}
          <aside className="lg:col-span-4 space-y-6">
            {/* Hot Tags */}
            <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200">
              <h3 className="text-sm font-semibold text-foreground-900 mb-4 flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                  <i className="ri-fire-line" />
                </span>
                热门标签
              </h3>
              <div className="flex flex-wrap gap-2">
                {['明星', '绯闻', '网红', '直播', '潜规则', '人设崩塌', '偷税', '学历造假', '隐婚', '退团'].map((tag) => (
                  <Link
                    key={tag}
                    to={`/category/entertainment`}
                    className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs font-medium hover:bg-primary-100 hover:text-primary-700 transition-colors"
                  >
                    {tag}
                  </Link>
                ))}
              </div>
            </div>

            {/* Daily Update Notice */}
            <div className="bg-primary-500 rounded-xl p-5 md:p-6 text-white">
              <div className="flex items-center gap-2 mb-3">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-notification-3-line" />
                </span>
                <h3 className="text-sm font-semibold">每日更新提醒</h3>
              </div>
              <p className="text-xs text-white/80 leading-relaxed mb-4">
                我们每天更新超过100条最新爆料，确保您不会错过任何热点事件。关注91吃瓜网，吃瓜永远快人一步。
              </p>
              <div className="flex items-center gap-1.5 text-xs text-white/70">
                <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
                今日已更新 47 条
              </div>
            </div>

            {/* Top Viewed */}
            <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200">
              <h3 className="text-sm font-semibold text-foreground-900 mb-4 flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                  <i className="ri-bar-chart-line" />
                </span>
                本周最热
              </h3>
              <div className="space-y-3">
                {articles.slice(0, 5).map((article, idx) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="flex items-start gap-3 group"
                  >
                    <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded text-xs font-bold ${
                      idx < 3 ? 'bg-primary-500 text-white' : 'bg-background-200 text-foreground-500'
                    }`}>
                      {idx + 1}
                    </span>
                    <span className="text-sm text-foreground-700 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                      {article.title}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}